import { PopoverPlacement } from "@idui/react-popover";
import { FC, PropsWithChildren } from "react";

import { FloatingMenuTooltipStyled } from "./floating-menu.styled";

interface IFloatingMenuTooltipWrapper extends PropsWithChildren {
  tooltip: string;
}

export const FloatingMenuTooltipWrapper: FC<IFloatingMenuTooltipWrapper> = ({
  tooltip,
  children,
}) => {
  return (
    <FloatingMenuTooltipStyled
      title={tooltip}
      content={tooltip}
      spaceBetweenPopoverAndTarget={13}
      placement={PopoverPlacement.top}
    >
      <>{children}</>
    </FloatingMenuTooltipStyled>
  );
};

interface IFloatingMenuTooltipWrapperIfDisabled extends IFloatingMenuTooltipWrapper {
  disabled: boolean;
}

export const FloatingMenuTooltipWrapperIfDisabled: FC<
  IFloatingMenuTooltipWrapperIfDisabled
> = ({ disabled, children, ...rest }) => {
  if (!disabled) {
    return children;
  }

  return (
    <FloatingMenuTooltipWrapper {...rest}>
      {children}
    </FloatingMenuTooltipWrapper>
  );
};
